import { red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";

export const useClassNames = makeStyles((theme) => ({
	errorMessage: {
		color: red[400],
		paddingBottom: theme.spacing(2)
	}
}));
